import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { LoggingService } from '@app/service/logging-service/logging.service';
import { environment } from 'src/environments/environment';
import { EnvIdentifier } from 'src/environments/environment-types';

@Component({
  selector: 'app-kreditz-iframe',
  templateUrl: './kreditz-iframe.component.html',
  styleUrls: ['./kreditz-iframe.component.scss'],
})
export class KreditzIframeComponent {
  constructor(private loggingService: LoggingService) {}
  @Input() iframeUrl: SafeResourceUrl;
  @Output() onEventData: EventEmitter<Data> = new EventEmitter();


  frameEventListener: EventListenerOrEventListenerObject =
    this.handleFrameMessage.bind(this);

  ngOnDestroy(): void {
    window.removeEventListener('message', this.frameEventListener, false);
  }

  ngAfterViewInit(): void {
    window.addEventListener('message', this.frameEventListener, false);
  }

  handleFrameMessage(kreditzMessageData: MessageEvent): void {
    if (environment.envIdentifier === EnvIdentifier.PROD) {
      if (kreditzMessageData.origin !== 'https://vista.kreditz.com') {
        return; //Ignore message if not sent by kreditz...
      }
    } else {
      if (
        kreditzMessageData.origin !== 'https://vista.kreditz.com' &&
        kreditzMessageData.origin !== 'https://sandbox-vista.kreditz.com'
      ) {
        return; //Ignore message if not sent by kreditz...
      }
    }

    if (kreditzMessageData && kreditzMessageData.data) {
      let data: Data;

      if (typeof kreditzMessageData.data === 'string') {
        try {
          data = JSON.parse(kreditzMessageData.data);
        } catch (e) {
          this.loggingService.warn(
            'Invalid JSON from iframe:',
            kreditzMessageData.data
          );
          return;
        }
      } else {
        data = kreditzMessageData.data;
      }
      this.loggingService.warn(
        'Kreditz responded with data: ' + JSON.stringify(data)
      );


      if (
        (data.status === EventStatus.SUCCESS && data.message === EventMessage.COMPLETED) ||
        data.status === EventStatus.ERROR ||
        data.message === EventMessage.USER_CANCELLED
      ) {
        this.onEventData.emit(data);
      }
    }
  }
}

export enum EventStatus {
  SUCCESS = 'success',
  ERROR = 'error',
}

export enum EventMessage {
  BANK_SELECTED = 'bank selected',
  BANK_AUTHENTICATION_STARTED = 'banking authentication started',
  USER_CANCELLED = 'user cancelled bank authentication',
  BANK_AUTHENTICATION_FINISHED = 'bank banking authentication finished',
  COMPLETED = 'User flow completed',
  ERROR = 'server error',
}

export interface Data {
  status: EventStatus;
  case_id: string;
  message: EventMessage;
}
